import { gql } from "@apollo/client";

export const GET_CATEGORIES = gql`
  query getAllCategories(
    $skip: Float!
    $take: Float!
    $filter: CatFilterInput
  ) {
    getAllCategories(skip: $skip, take: $take, filter: $filter) {
      count
      result {
        id
        name
        type
        assetCategoryClass {
          id
          name
        }
        category {
          id
          name
        }
        createdAt
        updatedBy {
          firstName
          lastName
        }
        createdBy {
          firstName
          lastName
        }
        isApprove
      }
    }
  }
`;

export const GET_CATEGORIES_BY_ID = gql`
  query getCategoryByCategoryId($categoryId: String!) {
    getCategoryByCategoryId(categoryId: $categoryId) {
      category {
        id
        name
        type
        assetCategoryClass {
          id
          name
        }
        category {
          id
          name
        }
      }
      attribute {
        id
        name
        type
        badge
      }
    }
  }
`;
